import React, { FunctionComponent } from 'react';
import WideContent from 'core/layout/content/wide-content';
import WithAuthenticatedPage from 'core/auth/components/with-authenticated-page';
import { AppType } from 'core/auth/types';
import Translate from 'ui/atoms/translate';
import WithDataRecord from 'hoc/WithDataRecord';
import { Document, DocumentsApi, DocumentsListOrderingEnum } from 'api';
import DashboardDocumentsTable from '../../shared/dashboard-documents-table';

const DashboardDocumentsDataRecordTable: FunctionComponent = WithDataRecord<DocumentsApi, Document>(DocumentsApi)(
  ({ data, ordering, onOrderBy, loading, paginationProps }) => {
    return (
      <>
        <DashboardDocumentsTable
          onOrderBy={onOrderBy}
          ordering={ordering}
          documents={data}
          loading={loading}
          paginationProps={paginationProps}
        />
      </>
    );
  },
  (api, props, offset, limit, ordering) => {
    return api.documentsList({
      offset,
      limit,
      ordering: ordering as DocumentsListOrderingEnum,
      ...props,
    });
  },
);

const InvestorDocumentsPage = () => {
  return (
    <WideContent title={<Translate name="dashboard.investorDocuments" />}>
      <DashboardDocumentsDataRecordTable />
    </WideContent>
  );
};

export default WithAuthenticatedPage(InvestorDocumentsPage, AppType.INVESTOR);
